import { PolicyNotFoundScreenComponent } from '../../../../components/screens/signup-process/policy-not-found-screen/policy-not-found-screen.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, PolicyNotFoundScreenComponent],
  selector: 'app-signup-not-found',
  templateUrl: './signup-not-found.component.html',
})
export class SignupNotFoundComponent implements OnInit {
  showMessageApp = false;
  isAcmic = false;

  constructor(
    private acmicService: AcmicService
  ) {}

  ngOnInit() {
    if (Capacitor.isNativePlatform()) {
      this.showMessageApp = true;
    }
    this.isAcmic = this.acmicService.isACMIC();
  }
}
